import styled from '@emotion/styled'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

const P = styled.p<{
  isBold: boolean
  color?: string
  isMobile: boolean
  whiteSpace: boolean
}>`
  color: ${(props) => (props.color ? props.color : '#F9F9FB')};
  font-size: ${(props) => (props.isMobile ? '16px' : '20px')};

  line-height: 160%;
  word-break: ${(props) => (props.whiteSpace ? 'normal' : 'keep-all')};
  white-space: ${(props) => (props.whiteSpace ? 'pre-wrap' : 'normal')};
  font-weight: ${(props) => {
    if (props.isMobile) {
      return props.isBold ? '600' : '400'
    }
    return props.isBold ? '700' : '400'
  }};
  @media screen and (min-width: 1100px) {
    word-break: normal;
    white-space: pre;
  }
`

const BodyText = ({
  text = '',
  isBold = true,
  color = '',
  whiteSpace = true,
}: {
  text: string
  isBold?: boolean
  color?: string
  whiteSpace?: boolean
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:1099px)' })

  return (
    <P
      isBold={isBold}
      color={color}
      isMobile={isMobile}
      whiteSpace={whiteSpace}
    >
      {text}
    </P>
  )
}

export default BodyText
